import BEMHelper from 'react-bem-helper';

export const bem = BEMHelper({ name: 'WeekEvent', outputIsString: true });
